import { render, staticRenderFns } from "./sato-partner-day-2026-banner.vue?vue&type=template&id=510816ef&scoped=true&"
import script from "./sato-partner-day-2026-banner.vue?vue&type=script&lang=js&"
export * from "./sato-partner-day-2026-banner.vue?vue&type=script&lang=js&"
import style0 from "./sato-partner-day-2026-banner.vue?vue&type=style&index=0&id=510816ef&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510816ef",
  null
  
)

export default component.exports